/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ price: NonNullable<unknown> }} Directory_Submit_Review_Pro_PriceInputs */

const en_directory_submit_review_pro_price = /** @type {(inputs: Directory_Submit_Review_Pro_PriceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.price}/month`)
};

const zh_directory_submit_review_pro_price = /** @type {(inputs: Directory_Submit_Review_Pro_PriceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.price}/月`)
};

/**
* | output |
* | --- |
* | "{price}/month" |
*
* @param {Directory_Submit_Review_Pro_PriceInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_review_pro_price = /** @type {((inputs: Directory_Submit_Review_Pro_PriceInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Review_Pro_PriceInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_review_pro_price(inputs)
	return zh_directory_submit_review_pro_price(inputs)
});
export { directory_submit_review_pro_price as "directory.submit.review.pro_price" }